import { useAuth as useClerkAuth } from '@clerk/clerk-react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { RouteErrorBoundary } from '@/components/ErrorBoundary';

interface ClerkProtectedRouteProps {
  children: React.ReactNode;
}

export const ClerkProtectedRoute = ({ children }: ClerkProtectedRouteProps) => {
  const { isLoaded, isSignedIn } = useClerkAuth();
  const location = useLocation();

  // Show loading while Clerk is initializing
  if (!isLoaded) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-2">Loading...</span>
      </div>
    );
  }

  // Redirect to sign-in if not authenticated
  if (!isSignedIn) {
    return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  }

  // Render children if authenticated — inside a route-scoped error boundary
  // (VF-37) so a render crash in one page doesn't take down the whole app.
  return <RouteErrorBoundary>{children}</RouteErrorBoundary>;
};
